import dayjs from "dayjs";

import { SupportedLngsType } from "./helper";

export const dayjsLocales: {
  [lang in SupportedLngsType]: () => Promise<ILocale>;
} = {
  en: () => import("dayjs/locale/en").then((m) => m.default as ILocale),
  fr: () => import("dayjs/locale/fr").then((m) => m.default as ILocale),
};

export const setDayjsLocale = async (language: SupportedLngsType) => {
  const currentLocale =
    dayjsLocales[language] ?? dayjsLocales[SupportedLngsType.FR];
  await currentLocale().then((locale) => {
    dayjs.locale(locale.name);
  });
};
